import { Info } from "lucide-react";

export default function Disclaimer({ children, className = "", testid = "disclaimer" }) {
  return (
    <div
      data-testid={testid}
      className={`flex gap-3 rounded-r-lg border-l-4 border-cyber bg-graphite p-4 text-xs sm:text-sm text-slate-300 ${className}`}
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-cyber" />
      <div className="leading-relaxed">
        {children || (
          <>
            <strong className="text-slate-100">Heads up:</strong> Prices update live in PKR. Per-game FPS figures are{" "}
            <span className="text-cyber">real chipset benchmark averages</span> - actual performance varies with
            thermals, display and game version. Thermals, gyro and PTA tax are not yet independently lab-tested.
            Always verify current price and availability before buying.
          </>
        )}
      </div>
    </div>
  );
}
